import type { IJourney } from '../../../../models/journey.model';
import type { ILegBase } from '../../../../models/leg-base.model';
import type { IOccupancy } from '../../../../models/occupancy.model';
import { ArrivalAccessLinkApiModel } from './arrival-accesslink.api-model';
import { ConnectionLinkApiModel } from './connection-link.api-model';
import { DepartureAccessLinkApiModel } from './departure-access-link.api-model';
import { DestinationLinkApiModel } from './destination-link.api-model';
import { TripLegApiModel } from './trip-leg.api-model';

export class JourneyApiModel {
  public static mapToBusinessModel(apiModel: JourneyApiModel): IJourney {
    return {
      detailsReference: apiModel.detailsReference,
      departureAccessLink: apiModel.departureAccessLink ? DepartureAccessLinkApiModel.mapToBusinessModel(apiModel.departureAccessLink) : undefined,
      tripLegs: apiModel.tripLegs ? apiModel.tripLegs.map(TripLegApiModel.mapToBusinessModel) : undefined,
      connectionLinks: apiModel.connectionLinks ? apiModel.connectionLinks.map(ConnectionLinkApiModel.mapToBusinessModel) : undefined,
      arrivalAccessLink: apiModel.arrivalAccessLink ? ArrivalAccessLinkApiModel.mapToBusinessModel(apiModel.arrivalAccessLink) : undefined,
      isDeparted: apiModel.isDeparted,
      occupancy: apiModel.occupancy,
      id: 0, // The id is set on all journeys in the calling method (using the JourneyHelper.setJourneyIds method)
      destinationLink: apiModel.destinationLink ? DestinationLinkApiModel.mapToBusinessModel(apiModel.destinationLink) : undefined,
      allLegs: this.mapAllLegs(apiModel),
    };
  }

  private static mapAllLegs(apiModel: JourneyApiModel): ILegBase[] {
    const allLegs: ILegBase[] = [];

    if (apiModel.tripLegs) {
      apiModel.tripLegs.forEach((tripLeg) => {
        allLegs.push(TripLegApiModel.mapToBusinessModel(tripLeg));
      });
    }

    if (apiModel.connectionLinks) {
      apiModel.connectionLinks.forEach((connectionLink) => {
        allLegs.push(ConnectionLinkApiModel.mapToBusinessModel(connectionLink));
      });
    }

    return allLegs.sort((a, b) => a.journeyLegIndex - b.journeyLegIndex);
  }

  public reconstructionReference?: string;
  public detailsReference?: string;
  public departureAccessLink?: DepartureAccessLinkApiModel;
  public tripLegs?: TripLegApiModel[];
  public connectionLinks?: ConnectionLinkApiModel[];
  public arrivalAccessLink?: ArrivalAccessLinkApiModel;
  public isDeparted?: boolean;
  public occupancy?: IOccupancy;
  public destinationLink?: DestinationLinkApiModel;
}
